import React from 'react'

const Credit = () => {
  return (
    <div className='z-40 flex flex-col items-center justify-center pt-12'>
      <div>
        Dibuat oleh <a href="http://fandiarfa26.vercel.app/" target="_blank" rel='noreferrer' className="text-ijo-dark hover:text-green-700">M. Fandi Arfabuma</a>
      </div>
      <div className="py-4 border border-ijo-dark bg-ijo-dark"></div>
    </div>
  )
}

export default Credit